// Central site + contact configuration. Edit these to update links everywhere.
export const SITE = {
  name: "Brahmandnayak World Trade",
  short: "BWT",
  tagline: "India to the World. Built for Global Trade.",
  email: "bwtuniverse@gmail.com",
  phone: "+91 91724 81515",
  phoneHref: "tel:+919172481515",
  whatsapp: "https://wa.me/919172481515",
  instagram: "https://www.instagram.com/bwtuniverse_?igsi=ZDNlZDc0MzIxNw==",
  linkedin: "https://www.linkedin.com/company/brahmandnayak-world-trade/",
  facebook: "https://www.facebook.com/share/19PDAubGev/",
  location: "https://share.google/sMvCVeqzeS5lZV00g",
  locationLabel: "India",
};

// Shared feature highlights + spec defaults used across product pages.
const FEATURES = ["Natural Fibres", "Super Soft", "Quick Absorption", "Colour-fast Dyes", "Custom GSM", "Export Grade"];
const CUSTOMIZATION = ["Private Label", "Custom Embroidery", "Logo Weaving", "Custom Packaging", "Barcode Labels", "Custom Borders"];
const YARN_OPTIONS = ["100% Cotton", "Combed Cotton", "Zero-Twist Yarn", "Ring-Spun Yarn", "Open-End (OE) Yarn", "80/20 C/PC Blend", "Recycled Yarn", "Bamboo Blend"];

const baseSpecs = (size, gsm) => [
  { k: "Minimum Order Quantity", v: "As per buyer requirement" },
  { k: "Size", v: size },
  { k: "Colour", v: "Assorted / As per Pantone shades" },
  { k: "Design / Pattern", v: "Plain, Dobby & Jacquard" },
  { k: "Material", v: "100% Cotton, Combed Cotton, Zero-Twist, Poly-Cotton Blend" },
  { k: "Wash Care", v: "Do not bleach · Do not iron · Tumble dry low · Wash dark colours separately" },
  { k: "Weight", v: gsm },
  { k: "Packaging Type", v: "Roll or Folded" },
  { k: "Country of Origin", v: "India" },
];

export const PRODUCT_CATEGORIES = [
  {
    key: "bath",
    name: "Bath Towels",
    tagline: "Everyday luxury, ready to brand",
    spec: "70×140 to 90×180 cm · GSM 450–750",
    sizes: ["70×140", "70×150", "75×150", "80×160", "90×160", "90×180 cm"],
    gsm: "450–750 GSM",
    blurb: "Plush, high-absorbency bath towels engineered for daily luxury and long-lasting softness.",
    longDesc: "Classic plain-weave bath towels manufactured from long-staple cotton with a soft, absorbent terry pile. A dependable, ready-to-brand base product for hotels, retail programmes and private-label towel manufacturers.",
  },
  {
    key: "hand",
    name: "Hand Towels",
    tagline: "Compact, quick-drying essentials",
    spec: "40×60 to 50×100 cm · GSM 400–650",
    sizes: ["40×60", "40×65","40×70", "40×75", "45×70","45×75","50×90","50×100 cm"],
    gsm: "400–650 GSM",
    blurb: "Compact, quick-drying hand towels for homes, hotels and washrooms.",
    longDesc: "Durable hand towels woven for high-traffic washrooms and hospitality use. Quick-drying, soft to the touch and available across a full range of colours, borders and logos.",
  },
  {
    key: "face",
    name: "Face Towels",
    tagline: "Gentle, refined daily care",
    spec: "30×30 to 30×50 cm · GSM 350–600",
    sizes: ["30×30", "33×33", "30×45", "30×50 cm"],
    gsm: "350–600 GSM",
    blurb: "Soft, gentle face towels with a refined feel for everyday care.",
    longDesc: "Fine, gentle face towels designed for comfort against the skin. Perfect for spas, salons, hotels and premium retail sets, with customisable weight and finish.",
  },
  {
    key: "pool",
    name: "Pool Towels",
    tagline: "Oversized durability for leisure",
    spec: "75×150 to 100×180 cm · GSM 450–750",
    sizes: ["75×150", "90×150", "90×180", "100×180 cm"],
    gsm: "450–750 GSM",
    blurb: "Oversized, durable pool towels built for resorts, clubs and leisure.",
    longDesc: "Generously sized pool towels built to withstand chlorine, sun and frequent laundering. A reliable choice for resorts, clubs and leisure destinations.",
  },
  {
    key: "beach",
    name: "Beach Towels",
    tagline: "Vivid prints, quick-dry weave",
    spec: "70×140 to 100×180 cm · GSM 350–650",
    sizes: ["70×140", "75×150", "90×150", "90×180", "100×180 cm"],
    gsm: "350–650 GSM",
    blurb: "Vibrant, lightweight beach towels with vivid prints and quick-dry weave.",
    longDesc: "Lightweight, vibrant beach towels available in reactive prints, stripes and custom artwork. Quick-drying and packable for retail and promotional programmes.",
  },
  {
    key: "kitchen",
    name: "Kitchen Towels",
    tagline: "Hard-working absorbency",
    spec: "30×45 to 50×75 cm · GSM 300–500",
    sizes: ["30×45", "40×60", "40×70", "45×70", "50×75 cm"],
    gsm: "300–500 GSM",
    blurb: "Hard-working, absorbent kitchen towels for hospitality and home use.",
    longDesc: "Practical, highly absorbent kitchen towels for restaurants, hotels and home use. Durable weave with options for checks, stripes and custom borders.",
  },
  {
    key: "mats",
    name: "Bath Mats",
    tagline: "Dense, heavyweight comfort",
    spec: "50×70 to 50×80 cm · GSM 600–1,000",
    sizes: ["50×70", "50×80 cm"],
    gsm: "600–1,000 GSM",
    blurb: "Dense, heavyweight bath mats with superb underfoot comfort and grip.",
    longDesc: "Heavyweight, densely woven bath mats offering plush underfoot comfort and excellent water absorption. Ideal for hotels, spas and premium bathrooms.",
  },
  {
    key: "jacquard",
    name: "Jacquard Towels",
    tagline: "Signature patterns & logos",
    spec: "30×30 to 100×180 cm · GSM 400–750 · Custom patterns",
    sizes: ["30×30", "40×70", "70×140", "75×150", "90×180", "100×180 cm"],
    gsm: "400–750 GSM",
    blurb: "Custom jacquard weaving with borders, logos and signature patterns.",
    longDesc: "Available in Face, Hand, Bath, Pool and Beach towel sizes with customised jacquard patterns, borders, logos and designs — a premium option for brand-led programmes.",
  },
  {
    key: "robes",
    name: "Bath Robes",
    tagline: "Spa-grade comfort & warmth",
    spec: "S to XXL · GSM 300–500",
    sizes: ["S", "M", "L", "XL", "XXL"],
    gsm: "300–500 GSM",
    blurb: "Plush terry and velour bathrobes for hotels, spas and premium retail.",
    longDesc: "Soft, absorbent bathrobes in terry and velour finishes with shawl or kimono collars. Tailored for hotels, spas and resorts, with custom sizes, colours and embroidered logos.",
  },
  {
    key: "floormats",
    name: "Floor Mats",
    tagline: "Heavyweight underfoot comfort",
    spec: "152×229 to 274×305 cm · GSM 800–1,500",
    sizes: ["152×229", "183×254", "229×274", "274×274", "274×305 cm"],
    gsm: "800–1,500 GSM",
    blurb: "Dense, high-GSM cotton floor and door mats with excellent grip and absorbency.",
    longDesc: "Heavyweight woven cotton floor mats offering plush underfoot comfort, high absorbency and lasting durability for bathrooms, entrances and high-traffic areas.",
  },
  {
    key: "bamboo",
    name: "Bamboo Towels",
    tagline: "Naturally soft & antibacterial",
    spec: "30×30 to 75×150 cm · GSM 350–650",
    sizes: ["30×30", "40×70", "70×140", "75×150 cm"],
    gsm: "350–650 GSM",
    blurb: "Naturally antibacterial, ultra-soft bamboo towels with superior absorbency.",
    longDesc: "Luxuriously soft bamboo-blend towels that are naturally antibacterial, highly absorbent and quick-drying — a premium, eco-friendly alternative to cotton.",
    whyFeatures: [
      { icon: "shield", title: "Natural Anti-bacterial, Antifungal", desc: "Inhibits the growth of bacteria and fungus." },
      { icon: "absorb", title: "Highly Absorbent", desc: "Instant water absorbency — 2x faster than cotton." },
      { icon: "retain", title: "High Water-retention", desc: "Three times more water-retaining capacity than cotton." },
      { icon: "dry", title: "Fast Drying", desc: "Dries faster than cotton thanks to moisture-wicking properties." },
      { icon: "light", title: "Light Weight", desc: "Light weight and easy to carry." },
      { icon: "soft", title: "Softest Fabric", desc: "Softer than silk — one of the softest fabrics available." },
    ],
  },
  {
    key: "chaddar",
    name: "Chaddar",
    tagline: "Woven cotton bed sheets",
    spec: "137×229 to 229×254 cm · GSM 120–250",
    sizes: ["137×229", "152×229","183×229","183×254", "229×254 cm"],
    gsm: "120–250 GSM",
    blurb: "Woven cotton chaddars and bed sheets in custom sizes, colours and designs.",
    longDesc: "Soft, breathable woven cotton chaddars and bed sheets available in single, double and king sizes, with custom colours, prints and borders for home, hospitality and institutional use.",
  },
].map((p) => ({
  ...p,
  features: FEATURES,
  customization: CUSTOMIZATION,
  yarns: p.key === "bamboo" ? ["Bamboo"] : YARN_OPTIONS,
  specs: baseSpecs(p.sizes.join(", "), p.gsm),
}));

export const getProduct = (key) => PRODUCT_CATEGORIES.find((p) => p.key === key);

// In-house manufacturing process steps (image = Cloudinary public ID).
export const PROCESSES = [
  { id: "yarn_selection", title: "Yarn Selection", summary: "Sourcing and selecting premium cotton and blended yarns matched to the required GSM, strength and hand-feel." },
  { id: "tfo", title: "TFO Twisting", summary: "Two-for-One twisting doubles and strengthens the yarn for a durable, long-lasting terry pile." },
  { id: "sizing", title: "Sizing", summary: "A protective starch coating is applied to the warp yarns to reduce breakage during high-speed weaving." },
  { id: "warping", title: "Warping", summary: "Thousands of warp threads are wound onto beams under uniform tension, ready for the loom." },
  { id: "weaving", title: "Weaving", summary: "Modern rapier looms interlace warp and weft to build the absorbent terry structure and borders." },
  { id: "dyeing", title: "Dyeing", summary: "Fabric is dyed with colour-fast, skin-safe dyes to achieve vibrant, consistent and wash-durable shades." },
  { id: "cutting", title: "Cutting", summary: "Woven fabric is precisely cut to size for each towel, mat, robe or chaddar specification." },
  { id: "stitching", title: "Stitching", summary: "Edges, hems and borders are stitched with reinforced seams for a clean, durable finish." },
  { id: "final_inspection", title: "Final Inspection", summary: "Every piece is inspected for weight, size, colour and quality before it is approved." },
  { id: "folding_packing", title: "Folding & Packaging", summary: "Finished goods are folded, labelled and packed to buyer specifications, ready for export." },
];
